/**
 * What a signed-in user's role lets them do in the portal.
 *
 * These mirror the rules each engine now enforces on the server (SessionRoleConfig
 * in each engine): the portal only hides what the server would refuse anyway.
 *
 *   ADMIN    — everything, including users, signing keys and certificates
 *   OPERATOR — day-to-day work: messages, transactions, certification
 *   VIEWER   — read-only
 *
 * A role the portal does not know, or none, counts as VIEWER, as on the server.
 */
const roleOf = (user) => String(user?.role || '').toUpperCase();

export const isAdmin = (user) => roleOf(user) === 'ADMIN';

export const isReadOnly = (user) => !['ADMIN', 'OPERATOR'].includes(roleOf(user));

/** A user's page opens to that user, or to an admin. */
export const canOpenUserPage = (user, userId) =>
  Boolean(user) && (isAdmin(user) || (user.id != null && String(user.id) === String(userId)));

/** FSP keys and signing certificates sign and verify as the institution: admins only. */
export const canManageSigningMaterial = (user) => isAdmin(user);
